/*eslint no-script-url: 0 */
import React from 'react';
//import Constants from './WooCommerce/Config';

export const GetProductCount = (props) => {
    var viewingProducts;
    (props.catProCount > 0) ? viewingProducts = props.catProCount : viewingProducts = props.allProductCount;
    return <h5>Viewing {viewingProducts} frames out of {props.allProductCount} frames</h5>;
}